import * as angular from 'angular';

import { ComponentDefinition, TicketViewModel } from '../../../../models';
import { computeDueInDays } from '../../computeDueInDays';
import { IticketColoringService } from '../../../../services';

class ChildTicketController implements angular.IComponentController {
    classed: { [className: string]: boolean; };
    dueInDays: string;
    
    readonly ticket: TicketViewModel;

    static $inject = ['$translate', 'ticketColoringService'];
    constructor(private _$translate: angular.translate.ITranslateService,
        private _ticketColoringService:IticketColoringService) {
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (this.ticket) {
            this.dueInDays = computeDueInDays(this.ticket, this._$translate);
            this.classed = this._ticketColoringService.getClass(this.ticket);
        }
    }

}

export const wtChildTicket: ComponentDefinition = {
    componentId: 'wtChildTicket',
    controller: ChildTicketController,
    template: require('./childTicket.component.html'),
    controllerAs: 'vm',
    bindings: {
        ticket: '<',
        onDragStart: '&?'
    }
};
